module.exports = __webpack_public_path__ + "media/images/second-registration-background-94cbc700c4d6c0f57234ced27d7b74c2.png";